import { Box, H6, Media, Optional } from '@honda-canada/design-system-react';
import { compiler } from 'markdown-to-jsx';
import React, { useMemo } from 'react';
import { SplideSlide } from '@splidejs/react-splide';
import CarouselSlider from '../MinimalCarousel';
import themeStyles from './CardGridSection.styles';
import { FOUR_CARD_LAYOUT_VARIANT } from './constants';
const Wrapper = themeStyles.apply(Box, 'Wrapper');
const Title = themeStyles.apply(H6, 'Title');
const List = themeStyles.apply(Box, 'List');
const CardGridSection = ({ title = '', items, render, componentName, hasFourColumn, showSlider = true, variant, }) => {
    const renderedItems = useMemo(() => items === null || items === void 0 ? void 0 : items.map(render), [items, render]);
    return (React.createElement(Wrapper, { "data-testid": "cy-card-grid", as: "section", "data-gtm-component-type": componentName, variant: hasFourColumn && FOUR_CARD_LAYOUT_VARIANT },
        React.createElement(Optional, { when: title.length },
            React.createElement(Title, { "data-testid": "cy-card-grid-title" }, compiler(title.replace(/-/g, ''), {}))),
        React.createElement(Media, { greaterThanOrEqual: "smallTablet" },
            React.createElement(List, { "data-testid": "cy-card-grid-list", variant: variant || (hasFourColumn && FOUR_CARD_LAYOUT_VARIANT) }, renderedItems)),
        React.createElement(Media, { lessThan: "smallTablet" },
            React.createElement(Optional, { when: showSlider },
                React.createElement(CarouselSlider, { arrowColor: "black", length: renderedItems === null || renderedItems === void 0 ? void 0 : renderedItems.length }, () => renderedItems === null || renderedItems === void 0 ? void 0 : renderedItems.map(item => React.createElement(SplideSlide, { key: `splide-slide-${item.key}` }, item)))),
            React.createElement(Optional, { when: !showSlider },
                React.createElement(List, { "data-testid": "cy-card-grid-list", variant: variant }, renderedItems)))));
};
export default CardGridSection;
